import React from "react";
import CustomCheckbox from "./customCheckbox";
import { SFCancelTwoToneIcon, SFCheckCircleIcon } from "../icons";
import { PROPS as IconProps} from "../icons/props";
import SFSpinner from "../spinner";

const SFIncludeCheckbox = ({ onChange, label, labelPlacement, variant="formElementText", size = "medium", checked = false, disabled=false, indeterminate=false }) => {
  return (
    <CustomCheckbox
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      variant={variant}
      label={label}
      labelPlacement={labelPlacement}
      indeterminate={indeterminate}
      indeterminateIcon={<SFSpinner disableShrink size={size} color="gray600" />}
      icon={<SFCancelTwoToneIcon size={size} color="grey300" />}
      checkedIcon={<SFCheckCircleIcon size={size} color="gray600" />}
    />
  );
};

SFIncludeCheckbox.propTypes = {
  /* Variant of the label text. */
  variant: CustomCheckbox.propTypes.variant,
  /* Size of the checkbox. */
  size: IconProps.size,
  /* Label positioning if a label is supplied */
  labelPlacement: CustomCheckbox.propTypes.labelPlacement,
  /* The label to display */
  label: CustomCheckbox.propTypes.label,
  /* If true, the component is checked. */
  checked: CustomCheckbox.propTypes.checked,
  /* If true, the component is disabled. */
  disabled: CustomCheckbox.propTypes.disabled,
  /* Callback fired when the state is changed.*/
  onChange: CustomCheckbox.propTypes.onChange,
  /* Indicate if the CustomCheckbox is in state indeterminate, we use it to show the spinner while transitioning*/
  indeterminate: CustomCheckbox.propTypes.indeterminate,
};

export default SFIncludeCheckbox;
